import {
  API_REQUEST,
} from '../middlewares/authMiddleware.js';
import { replace } from 'react-router-redux';

export const RESERVATION_FETCH_SHOP_CITIES = Symbol('RESERVATION_FETCH_SHOP_CITIES');
export const RESERVATION_FETCH_SHOP_CITY_LIST = Symbol('RESERVATION_FETCH_SHOP_CITY_LIST');
export const RESERVATION_CHANGE_CITY = Symbol('RESERVATION_CHANGE_CITY');
export const RESERVATION_FORM_OPEN = Symbol('RESERVATION_FORM_OPEN');
export const RESERVATION_FORM_CLOSE = Symbol('RESERVATION_FORM_OPEN');
export const RESERVATION_CREATED = Symbol('RESERVATION_CREATED');

export function createReservation(customerId, storeId, time) {
  return dispatch => {
    dispatch({
      [API_REQUEST]: {
        types: [
          RESERVATION_CREATED,
        ],
        method: 'POST',
        entrypoint: '/reservations',
        json: true,
        body: {
          customerId,
          storeId,
          time,
        },
        onSuccess: () => {
          alert('預約成功！');
          dispatch(replace('/'));
        },
      },
    });
  };
}

export function closeReservationModal() {
  return {
    type: RESERVATION_FORM_CLOSE,
  };
}

export function openReservationModal(shop) {
  return {
    type: RESERVATION_FORM_OPEN,
    shop,
  };
}

export function updateCity(cityId) {
  return {
    type: RESERVATION_CHANGE_CITY,
    cityId,
  };
}

export function fetchShopCityList(cityId) {
  return {
    [API_REQUEST]: {
      types: [
        RESERVATION_FETCH_SHOP_CITY_LIST,
      ],
      method: 'GET',
      entrypoint: `/stores/cities/${cityId}`,
    },
  };
}

export function fetchShopCities() {
  return {
    [API_REQUEST]: {
      types: [
        RESERVATION_FETCH_SHOP_CITIES,
      ],
      method: 'GET',
      entrypoint: '/stores/cities',
    },
  };
}



// WEBPACK FOOTER //
// ./actions/Reservation.js